import { Box, Typography } from "@mui/material";
import LazyTooltip from "../lazyTooltip";

export default function CountWithLazyTooltipCell({
  endpoint,
  count,
  icon,
  iconSx,
  typographySx,
}) {
  const normalizedCount = Number.isFinite(count) ? count : 0;

  return (
    <LazyTooltip endpoint={endpoint} count={normalizedCount}>
      {(displayCount) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {icon ? (
            <Box component="span" sx={{ display: "flex", alignItems: "center" }}>
              {icon}
            </Box>
          ) : null}
          <Typography variant="body2" sx={typographySx || { fontWeight: 500 }}>
            {displayCount}
          </Typography>
        </Box>
      )}
    </LazyTooltip>
  );
}
